<template>
  <div class="monthly-report-list">
    <template v-if="notReady"></template>
    <template v-else-if="!searched && !notReady && !isOperationOffice && !isDepartment">
      <div class="not-searched">
        <label >
          {{ i18n.global.t('pages.common.list.runFilter') }}
        </label>
      </div>
    </template>
    <template v-if="listLoading">
      <div class="not-searched">
        <label>
          {{ i18n.global.t('pages.common.list.reading') }}
        </label>
      </div>
    </template>
    <ResizableList
      scrollAreaSelector=".v-table__wrapper"
    >
      <div class="table-scrollbar">
        <v-table>
          <thead>
            <tr class="table-header-row">
              <th class="select-column">
                <div class="checkbox-in-grid align-middle">
                <v-checkbox
                  outlined hide-details="false"
                  v-model="allSelect"
                  @change="toggleSelectAll"
                />
                </div>
              </th>
              <th class="text-body-large fw-bold">{{ showHeaderTitle() }}</th>
              <th class="text-body-large fw-bold">
                <div v-show="showableEditWorkingTimeItem()">
                  {{ i18n.global.t('pages.monthlyReport.list.inputWorkingTimes') }}
                </div>
              </th>
              <template v-if="isManagementOffice">
                <th
                  v-for="(reportType, index) in reportTypes"
                  :key="reportType.type"
                  class="text-body-large fw-bold report-status-header"
                  :class="getReportStatusFirstClass(index)"
                >
                  {{ i18n.global.t(reportType.label) }}
                </th>
                <th class="text-body-large fw-bold">
                  {{ i18n.global.t('pages.monthlyReport.list.clear') }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-if="items?.length != 0">
            <tr
              v-for="item in items"
              :key="item.id"
            >
              <td>
                <v-checkbox
                  class="align-middle checkbox-in-grid"
                  label=''
                  v-model="selectStatuses[`${item.id}`]"
                  @change="toggleSelect"
                />
              </td>
              <td class="text-title-small">{{ showDriverNameOrVehicleNumberPlate(item) }}</td>
              <td>
                <div class="d-flex" v-if="item.driver_id">
                  <button
                    class="material-symbols-outlined"
                    @click="moveToWorkingTimesSetting(item)"
                  >
                    edit_note
                  </button>
                </div>
              </td>
              <template v-if="isManagementOffice">
                <td
                  v-for="(reportType, index) in reportTypes"
                  :key="reportType.type"
                  class="text-title-small report-status-cell"
                  :class="getReportStatusFirstClass(index)"
                >
                  <span class="fw-bold">
                    {{ getReportStatus(item, reportType.type).status }}
                  </span>
                  <span class="ms-2">
                    {{ getReportStatus(item, reportType.type).datetime }}
                  </span>
                  <v-tooltip v-if="getReportStatus(item, reportType.type).statusMessage" location="top">
                    <template #activator="{ props }">
                      <span v-bind="props" class="material-symbols-outlined status-message-icon ms-2">
                        error
                      </span>
                    </template>
                    {{ getReportStatus(item, reportType.type).statusMessage }}
                  </v-tooltip>
                </td>
                <td>
                  <div class="d-flex" v-if="showableClearButton(item)">
                    <button
                      class="material-symbols-outlined clear-button"
                      @click="clearMonthlyReport(item)"
                    >
                      delete
                    </button>
                  </div>
                </td>
              </template>
            </tr>
            </template>
            <template v-else-if="searched && !listLoading">
              <tr>
                <td colspan="2">
                  {{ i18n.global.t('pages.common.list.noData') }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </div>
    </ResizableList>
  </div>
</template>

<script>
import i18n from '@/lang/i18n';
import ResizableList from '@/components/ResizableList.vue';
import Api from "@/services/api/ApiServiceFabrick";

  export default {
    setup() {
      return {
        i18n
      }
    },
    props: {
      searched: null,
      operationOfficeId: null,
      monthly: null,
      items: [],
      listLoading: {
        type: Boolean,
        default: false
      },
      isOperationOffice: {
        type: Boolean,
        default: false
      },
      isDepartment: {
        type: Boolean
      },
      notReady: {
        type: Boolean,
        default: false
      },
      editableWorkingTime: {
        type: Boolean,
        default: false
      },
      isManagementOffice: {
        type: Boolean,
        default: false
      },
      showFlash: {
        type: Function
      }
    },
    data() {
      return {
        allSelect: false,
        selectStatuses: {},
        nameList: {
          all: i18n.global.t('pages.monthlyReport.list.all'),
          driver: i18n.global.t('pages.monthlyReport.driver'),
          vehicle: i18n.global.t('pages.monthlyReport.vehicle'),
        },
        statusList: {
          in_queue: i18n.global.t('pages.monthlyReport.preCreateStatus.inQueue'),
          in_progress: i18n.global.t('pages.monthlyReport.preCreateStatus.inProgress'),
          skipped: i18n.global.t('pages.monthlyReport.preCreateStatus.skipped'),
          succeeded: i18n.global.t('pages.monthlyReport.preCreateStatus.succeeded'),
          failed: i18n.global.t('pages.monthlyReport.preCreateStatus.failed'),
          unconfirmed: i18n.global.t('pages.monthlyReport.preCreateStatus.unconfirmed'),
        },
        reportTypes: [
          { type: 'driver_labor_detail', label: 'pages.monthlyReport.outputLayout.byDriverPreview' },
          { type: 'driver_labor_summary', label: 'pages.monthlyReport.outputLayout.laborSummaryTable' },
          { type: 'driver_notice_exceeding', label: 'pages.monthlyReport.outputLayout.noticeExceeding' },
        ],
        workingTimesSettingUrl: '/monthly-report/working-times/edit'
      }
    },
    computed: {
    },
    methods: {
      getReportStatusFirstClass(index) {
        if (index === 0) {
          return 'report-status-first';
        }
        return null;
      },
      getReportStatus(item, type) {
        if (!item || !item.monthly_report_statuses) {
          return { status: '-', datetime: null, statusMessage: null }
        }

        const report = item.monthly_report_statuses.find(status => status && status.type === type)
        if (!report) {
          return { status: '-', datetime: null, statusMessage: null }
        }

        const statusKey = report.status
        const status = this.statusList[statusKey] || statusKey || '-'
        const datetime = this.getReportDateTime(report)
        const statusMessage = report.status_message || null

        return { status, datetime, statusMessage }
      },
      getReportDateTime(report) {
        // 優先順位: finished_at > started_at > enqueued_at
        return report.finished_at ||
               report.started_at ||
               report.enqueued_at ||
               null
      },
      toggleSelectAll() {
        Object.keys(this.selectStatuses).forEach((key) => {
          this.selectStatuses[key] = this.allSelect
        })
        this.onChange()
      },
      toggleSelect() {
        this.allSelect = false
        this.onChange()
      },
      onChange() {
        const selected = { driver_ids: [], ids: [] }
        this.items.forEach((item) => {
          if (this.selectStatuses[item.id]) {
            if (item.driver_id) selected['driver_ids'].push(item.driver_id)
            selected['ids'].push(item.id)
          }
        })
        this.$emit('select', selected)
      },
      showDriverNameOrVehicleNumberPlate(item) {
        if (item.driver_id) return item.last_name + ' ' + item.first_name
        return item.number_plate
      },
      showHeaderTitle() {
        if (!this.items?.length) return this.nameList['all']
        if (this.items[0].driver_id) return this.nameList['driver']
        return this.nameList['vehicle']
      },
      showableEditWorkingTimeItem() {
        return (this.showHeaderTitle() == this.nameList['driver']) && this.editableWorkingTime;
      },
      showableClearButton(item) {
        // monthly_report_statusesが存在しない場合は表示しない
        if (!item.monthly_report_statuses || item.monthly_report_statuses.length === 0) {
          return false;
        }

        // いずれか1つでもin_queueまたはin_progressがあれば非表示
        const hasInProgressOrQueue = item.monthly_report_statuses.some(status => {
          return status.status === 'in_queue' || status.status === 'in_progress';
        });

        return !hasInProgressOrQueue;
      },
      moveToWorkingTimesSetting(item) {
        const queryParams = '?operation_office_id=' + this.operationOfficeId + '&account_id=' + item.id + '&monthly=' + this.monthly;

        window.open(this.workingTimesSettingUrl + queryParams, '_blank');
      },
      async clearMonthlyReport(item) {
        if (!confirm(i18n.global.t('pages.monthlyReport.messages.confirmClear'))) {
          return;
        }

        try {
          await Api().clearMonthlyReport(
            this.operationOfficeId,
            item.id,
            this.monthly
          );

          this.showFlash(
            i18n.global.t('pages.monthlyReport.messages.clearSuccess'),
            "success"
          );
          // 親コンポーネントにリロードを通知
          this.$emit('cleared');
        } catch (error) {
          console.error('Error clearing monthly reports:', error);
          if (error.response?.data?.message) {
            this.showFlash(
              i18n.global.t('pages.monthlyReport.messages.clearError', { message: error.response.data.message }),
              "error",
              false
            );
          } else if (error.response?.data?.errors) {
            // バリデーションエラーの表示
            const errors = Object.values(error.response.data.errors).flat().join('\n');
            this.showFlash(
              i18n.global.t('pages.monthlyReport.messages.clearValidationError', { errors: errors }),
              "error",
              false
            );
          } else {
            this.showFlash(
              i18n.global.t('pages.monthlyReport.messages.clearFailed'),
              "error",
              false
            );
          }
        }
      }
    },
    watch: {
      items: {
        handler() {
          this.selectStatuses = {}
          this.items.map((v) => {
            this.selectStatuses[v['id']] = false
          })
          this.allSelect = false
          this.onChange()
        }
      },
    },
    components: {
      ResizableList,
    },
  }

</script>

<style>
.monthly-report-list .v-table__wrapper{
  height: var(--resizable-height, var(--list-default-height));
  overflow: auto;
}
</style>
<style scoped>
.monthly-report-list {
  position: relative;
}
.monthly-report-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  min-width: 7em;
}
.monthly-report-list table .table-header-row th {
  z-index: 1;
}
.monthly-report-list table .table-header-row th:first-child {
  z-index: 2;
}
.checkbox-in-grid :first-child {
  height: inherit !important;
}
.checkbox-in-grid {
  padding: 1vm;
  display: inline-grid !important;
  transform: scale(1.2);
}
.select-column {
  width: 20%;
}
.report-status-first {
  border-left: 4px double #808080 !important;
  padding-left: 12px !important;
}
.clear-button {
  color: #dc3545 !important;
  border: none !important;
  background: none !important;
}
.status-message-icon {
  font-size: 24px;
  color: #fd7e14;
  vertical-align: middle;
  cursor: default;
}
</style>
